import React from "react";
import classNames from "classnames";

interface CardMediaProps {
    className?: string;
    image?: string;
    width?: number;
    height?: number;
    children?: any;
    [x: string]: any;
}

export const CardMedia = ({
    className,
    image,
    width,
    height,
    children,
    ...props
}: CardMediaProps) => (
    <div
        className={classNames("card-media", className)}
        style={{ backgroundImage: `url(${image})`, width, height }}
        {...props}
    >
        {children}
    </div>
);
